/* FRAWGRAPHY — dil sözlüğü
   Kaynak dil Türkçe: HTML'deki metin TR'dir ve JS kapalıyken de doğru görünür.
   Buradaki sözlük yalnızca İngilizce karşılıkları taşır. */
window.FRAWGRAPHY_I18N = {
  en: {
    /* Belge */
    'doc.title': 'Frawgraphy — Istanbul Fashion Photography Studio | Editorial, Campaign, Video',
    'doc.desc': 'Frawgraphy is an independent fashion photography studio in Beyoglu producing editorial, campaign and lookbook work. Videography and AI-assisted image making.',

    /* Başlık / gezinme */
    'nav.work': 'Work',
    'nav.digital': 'Digitally Created',
    'nav.video': 'Videography',
    'nav.studio': 'Studio',
    'nav.services': 'Services',
    'nav.contact': 'Contact',
    'nav.aria': 'Main sections',
    'brand.sub': 'Fashion Studio',
    'menu.label': 'Menu',
    'menu.location': 'Beyoglu, Istanbul — 41°02′N 28°58′E',
    'skip': 'Skip to content',
    'theme.toLight': 'Switch to light theme',
    'theme.toDark': 'Switch to dark theme',
    'lang.aria': 'Language',

    /* Hero */
    'hero.eyebrow': 'Est. 2016 — Independent',
    'hero.lede': 'An independent fashion photography studio producing editorial, campaign and lookbook work. We treat light as a material and the frame as a sentence.',
    'hero.cta1': 'Selected work',
    'hero.cta2': 'Book a shoot',
    'hero.hint': 'Move your cursor — colour follows the lens',

    /* Work */
    'work.index': 'Work',
    'work.title': 'Selected <em>work</em>',
    'cf.label': 'Selected work',
    'cf.prev': 'Previous frame',
    'cf.next': 'Next frame',
    'lb.label': 'Enlarged photograph',
    'lb.close': 'Close',
    'work.lede': 'From brand campaigns to independent editorial projects. Every series is built around a single decision about light.',
    'work.browseAll': 'Browse all works',

    /* Works archive */
    'works.docTitle': 'All Works — Fashion Photography Archive | Frawgraphy',
    'works.crumb': 'All works',
    'works.index': 'Archive',
    'works.title': 'All <em>works</em>',
    'works.lede': 'Editorial series, seasonal campaigns and beauty shoots in one place. Click a frame — it opens at full resolution.',
    'works.album.tag': 'Album',
    'works.album.name': 'Leather & Pearl',
    'works.album.count': '7 frames',
    'works.album.aria': 'Leather & Pearl album — 7 frames',

    /* Albüm */
    'album.docTitle': 'Leather & Pearl — Editorial Album | Frawgraphy',
    'album.crumb': 'Leather & Pearl',
    'album.index': 'Album — 7 frames, 2026',
    'album.title': 'Leather &amp; <em>Pearl</em>',
    'album.lede': 'Seven frames from a single studio day: leather, shearling and pearls. Click a frame — it opens at full resolution; use the strip below to move through the set.',

    'works.cta.title': 'The next series could be yours',
    'works.cta.text': 'Our calendar fills two months ahead. Send us the dates and the scope.',

    /* Digitally Created */
    'digital.index': 'Digitally Created',
    'digital.title': 'Generative <em>imagery</em>',
    'digital.lede': 'Concept images we make with AI. We use them to find direction before a campaign, to test impossible locations and to build moodboards.',
    'digital.disclosure': 'Every image in this section is generated with AI. None of them represents a photograph made with a camera.',
    'digital.cat': 'Concept',
    'digital.1.title': 'Synthetic Cloth',
    'digital.1.desc': 'Texture study — 32 variations',
    'digital.2.title': 'Surface / 02',
    'digital.2.desc': 'Campaign pre-visualisation',
    'digital.3.title': 'Seed of Light',
    'digital.3.desc': 'Set design experiment',

    /* Videography */
    'video.index': 'Videography',
    'video.title': 'Moving <em>record</em>',
    'video.lede': 'Short-form video shot on the same set as the stills. Same lighting plan, same crew, two deliverables in one day.',

    'reel.1.title': 'Quiet Current',
    'reel.1.spec': '16:9 & 9:16 · COLOUR GRADE · SOUND DESIGN',
    'reel.1.note': 'Atelier Sur FW25 campaign. Recorded on the same set as the stills, under the same lighting plan; print and social formats delivered in a single day.',
    'reel.2.title': 'Street Records',
    'reel.2.spec': '9:16 VERTICAL · STREET LIGHT · FAST CUT',
    'reel.2.note': 'A vertical lookbook film covering the whole collection. Shot in natural street light in one day, on a fixed-frame system.',
    'reel.3.title': 'Horizon Line',
    'reel.3.spec': 'STOP-MOTION · LIVE ACTION · COMPOSITE',
    'reel.3.note': 'Brand film. Frame-by-frame stop-motion sections were merged with live action; the transitions were planned on set, not in the edit.',
    'reel.4.title': 'Set Diary',
    'reel.4.spec': 'BACKSTAGE · LONG FORM · INTERVIEW',
    'reel.4.note': 'A documentary of a three-day campaign shoot. Crew, rehearsal and decision moments, recorded to explain the process to the client.',

    /* Studio */
    'studio.index': 'Studio',
    'studio.title': 'Light, patience and <em>one frame</em>',
    'studio.caption': '320 m² daylight studio — Beyoglu',
    'studio.p1': 'Since 2016 we have worked with fashion brands, magazines and styling teams. Small crew, fast decisions, plenty of rehearsal.',
    'studio.p2': 'We build the reference set together before the shoot and settle the lighting plan around a single idea on set. Delivery, including colour work and retouching, takes about ten working days.',
    'studio.stat1': 'Years', 'studio.stat2': 'Published', 'studio.stat3': 'Brands', 'studio.stat4': 'Countries',
    'studio.ctaText': 'If you are curious about the process, read what we have written.',
    'studio.ctaBtn': 'How we work',

    /* Services */
    'services.index': 'Services',
    'services.title': 'What we <em>do</em>',
    'services.1.title': 'Editorial',
    'services.1.desc': 'Narrative series for magazines and digital publications. Concept, casting and location included.',
    'services.1.meta': '2–4 days · 15–25 frames',
    'services.2.title': 'Campaign',
    'services.2.desc': 'Seasonal campaigns delivered in print, digital and outdoor formats.',
    'services.2.meta': '3–6 days · multi-format',
    'services.3.title': 'Lookbook',
    'services.3.desc': 'A consistent lighting and fixed-frame system for a whole collection.',
    'services.3.meta': '1–2 days · 40+ pieces',
    'services.4.title': 'Videography',
    'services.4.desc': 'Short-form video and stop-motion, produced on the same set as the stills.',
    'services.4.meta': 'same day · 9:16 & 16:9',

    /* Contact */
    'contact.index': 'Contact',
    'contact.title': 'Tell us about a <em>project</em>',
    'contact.lede': 'Our calendar fills two months ahead. Dates and scope are enough to start.',
    'contact.name': 'Full name',
    'contact.email': 'Email',
    'contact.emailHelp': 'We will send the quote to this address.',
    'contact.type': 'Project type',
    'contact.type.editorial': 'Editorial',
    'contact.type.campaign': 'Campaign',
    'contact.type.lookbook': 'Lookbook',
    'contact.type.video': 'Videography',
    'contact.type.digital': 'Generative imagery',
    'contact.type.other': 'Other',
    'contact.brief': 'Short brief',
    'contact.briefHelp': 'Date range, city and an estimated frame count help a lot.',
    'contact.submit': 'Send',
    'contact.studio': 'Studio',
    'contact.emailLabel': 'Email',
    'contact.phone': 'Phone',
    'contact.rep': 'Representation',
    'contact.repVal': 'Europe — Atelier Mgmt.<br>Turkey — direct',
    'contact.note': 'Response time: two work days.',

    /* Form geri bildirimi */
    'form.errName': 'Please enter your first and last name.',
    'form.errEmail': 'Enter a valid email address (e.g. name@brand.com).',
    'form.errBrief': 'Describe the project in a few sentences (20+ characters).',
    'form.errCount': 'field(s) need attention.',
    'form.sending': 'Sending',
    'form.success': 'Thank you — we have your brief. We will reply within two working days.',
    'form.error': 'Could not send — please try again.',

    /* Altbilgi */
    'footer.journal': 'Journal',
    'footer.press': 'Press kit',
    'footer.legal': '© 2026 Frawgraphy Studio — All rights reserved.',

    /* 404 */
    'notFound.docTitle': 'Page not found | Frawgraphy',
    'notFound.index': '404',
    'notFound.title': 'This frame <em>does not exist</em>',
    'notFound.lede': 'The page you were looking for may have moved, or may never have existed. The three places below hold all of the studio’s work.',
    'notFound.ctaTitle': 'Where to look',
    'notFound.ctaText': 'Selected work, the journal and contact — all one click away.',
    'notFound.ctaWork': 'Selected work',
    'notFound.ctaBlog': 'Journal',
    'notFound.ctaContact': 'Contact',

    /* Günlük */
    'blog.docTitle': 'Journal — Writing on Fashion Photography | Frawgraphy',
    'blog.crumbHome': 'Home',
    'blog.crumbBlog': 'Journal',
    'blog.index': 'Journal',
    'blog.title': 'How we <em>work</em>',
    'blog.lede': 'We write down what we learn on set: lighting plans, preparation, colour decisions and where new tools actually earn their place.',
    'blog.cta.title': 'Have a project?',
    'blog.cta.text': 'Our calendar fills two months ahead. Dates and scope are enough to start.',
    'blog.cta.btn': 'Book a shoot',
    'blog.notice': 'Articles are published in Turkish.',
    'blog.1.cat': 'Light',
    'blog.1.title': 'Editorial with one light: the grammar of a hard source',
    'blog.1.excerpt': 'Adding a softbox is not always the answer. How a single hard source turns shadow into a narrative tool, and three ways to control it.',
    'blog.2.cat': 'Preparation',
    'blog.2.title': 'Before the shoot: how to build a reference set that works',
    'blog.2.excerpt': 'Nobody reads a forty-image board. What a reference set the crew actually uses looks like, and the four headings it fits into.',
    'blog.3.cat': 'Method',
    'blog.3.title': 'When AI enters the set: what we generate, what we shoot',
    'blog.3.excerpt': 'We use generative images for pre-visualisation, not for delivery. Where we draw the line and how we explain it to clients.',
    'blog.4.cat': 'Colour',
    'blog.4.title': 'What to do in colour before converting to black and white',
    'blog.4.excerpt': 'Dropping saturation to zero is not a conversion. The channel-based way to keep skin tone while gaining contrast.',
    'blog.read': 'min read',
    'blog.all': 'All articles'
  }
};
